import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Box, Grid, Link, Typography, useMediaQuery } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { routes } from 'utils/routing';
import { useRouter } from 'next/router';
import NavigationDrawer from 'components/common/NavigationDrawer';

const useStyles = makeStyles()((theme) => ({
  navDrawer: {
    top: 20,
    '& > div': {
      top: 0,
      width: '240px',
    },
  },
  link: {
    fontWeight: 600,
  },
  linkActive: {
    color: theme.palette.text.secondary,
    fontWeight: 600,
  },
  linkContainer: {
    backgroundColor: theme.palette.custom.gray.light,
    borderRadius: '8px',
    marginTop: '28px',
    marginBottom: theme.spacing(2),
    width: 'fit-content',
  },
}));

const menuItems = [
  { label: 'Privacy Policy', route: routes.privacyPolicy(), document: 'privacy' },
  { label: 'Terms and Conditions', route: routes.termsOfUse(), document: 'terms' },
];

function DocumentsScreen({ top, title, children, sections, inModal, onNavigate }) {
  const { classes } = useStyles();
  const router = useRouter();

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));

  const content = (
    <Grid container>
      {!inModal && !isMobile && (
        <Grid item xs md={4}>
          <NavigationDrawer sections={sections} className={classes.navDrawer} label="Navigation" />
        </Grid>
      )}
      <Grid item xs={12} md={inModal ? 12 : 8}>
        <Grid container spacing={8}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography variant="h3">{title}</Typography>
              </Grid>
              <Grid item xs={12}>
                {top}
              </Grid>

              <Grid item xs={12}>
                <Grid container spacing={2} className={classes.linkContainer}>
                  {menuItems.map(({ label, route, document }) => {
                    let props;
                    if (route && !inModal) {
                      props = {
                        ...route,
                        className: router.pathname.includes(route.href) ? classes.linkActive : classes.link,
                      };
                    }
                    return (
                      <Grid key={String(label)} style={{ padding: 12 }}>
                        {inModal ? (
                          <Link
                            component="button"
                            type="button"
                            className={classes.link}
                            onClick={() => onNavigate(document)}
                            underline="none"
                          >
                            {label}
                          </Link>
                        ) : (
                          <Link href={route} {...props} underline="none">
                            {label}
                          </Link>
                        )}
                      </Grid>
                    );
                  })}
                </Grid>
                {children}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );

  if (inModal) {
    return content;
  }

  return (
    <Box p={4} mt={6}>
      {content}
    </Box>
  );
}

/* eslint-disable react/forbid-prop-types */
DocumentsScreen.propTypes = {
  top: PropTypes.node,
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  sections: PropTypes.arrayOf(PropTypes.object),
  inModal: PropTypes.bool,
  onNavigate: PropTypes.func,
};

DocumentsScreen.defaultProps = {
  sections: undefined,
  top: undefined,
  children: undefined,
  inModal: false,
  onNavigate: undefined,
};

export default memo(DocumentsScreen);
